/* eslint-disable prettier/prettier */

module.exports = {
  colors: {
    blueS: "#0C3642", // in old and new color palette
    blue: "#65767C", // was #66767A
    blueT: "#a6bac0", // in old and new color palette
    // blueTT: "#d6dfe2",    // unused
    blueTTT: "#F2F4F5", // same as grayTTT
    grayS: "#333333", // was #444444
    gray: "#767676", // was #6a6a6a
    grayT: "#C3C2BF", // was #dddddd
    grayTT: "#eaeaea", // in old and new color palette
    grayTTT: "#F2F4F5", // was #f2f2f2
    grayTTTT: "#fafbfb", // in old and new color palette
    green: "#879A75", // was #99af86
    orange: "#BF8C70", // was #daa080
    orangeT: "#D6AE97", // was #e4b8a0
    // orangeTT: "#eccfbf",  // unused
    // orangeTTT: "#f6e7df", // unused
    redS: "#ac4b3b",
    red: "#B95658", // was #c55947

    bley: "#DCE2E4",
    bleyT: "#EBEFEF",

    blueAlt: "#859ba1",
  },
  easings: {
    cubicOut: "cubic-bezier(0.33, 1, 0.68, 1)",
    quintOut: "cubic-bezier(0.23, 1, 0.32, 1)",
  },
  fonts: {
    base: "'Avenir LT Std', 'Helvetica Neue', Helvetica, Arial, sans-serif;",
    heading: "'Mercury Text G2', Georgia, 'Times New Roman', Times, serif;",
  },
  scale: {
    up5: "3.5rem",
    up4: "2.625rem",
    up3: "2rem",
    up2: "1.5rem",
    up1: "1.25rem",
    // new slot?           18px body
    base: "1rem", // 16px
    down1: "0.875rem", // 14px
    down2: "0.75rem", // 12px
    down3: "0.675rem", // 10px
  },
};

/* eslint-enable prettier/prettier */
